const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/layouts/routerParrent.vue");
const nationalLicenseList = () =>
  import("../views/nationalLicense/nationalLicenseList.vue");
const termMappingList = () =>
  import("../views/term-mapping/termMappingList.vue");

export const nationalLicenseRoute: any[] = [
  {
    path: "/national-license",
    name: "national-license",
    meta: {
      label: "مرکز ملی مجوز‌ها",
      requiresAuth: true,
      redesigned: true,
      moduleName: "nationalLicense",
    },
    component: newContainer,
    children: [
      {
        path: "national-license-center",
        name: "national_licensing_center",
        component: routerParent,
        redirect: "/national-license/national-license-center/list",
        meta: {
          label: "درخواست‌ها",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "national-licensing-center-list",
            component: nationalLicenseList,
            meta: {
              label: "درخواست‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "term-mapping",
        name: "national_license_term_mapping",
        component: routerParent,
        redirect: "/national-license/term-mapping/list",
        meta: {
          label: "تطبیق کد مجوز کاربرگ با دوره",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "term-mapping-list",
            component: termMappingList,
            meta: {
              label: "تطبیق کد مجوز کاربرگ با دوره",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
    ],
  },
];
